import PropTypes from 'prop-types';
import React from 'react';
import EmployeeLabel from '../../../employees/EmployeeLabel.jsx';
import InitiativeParticipationLabel from '../../InitiativeParticipationLabel.jsx';
import InitiativeParticipationStatus from '../../InitiativeParticipationStatus.jsx';
import InitiativeParticipationCompletionButton from './InitiativeParticipationCompletionButton.jsx';
import styles from './InitiativeParticipationsTableRow.module.css';

const InitiativeParticipationsTableRow = ({
  isPreview,
  initiative,
  depth,
  initiativeParticipation,
}) => {
  const { childrenCount, label, participantId, participantType, archived } =
    initiativeParticipation;

  const renderParticipant = () => {
    if (childrenCount) {
      return (
        <InitiativeParticipationLabel
          isPreview={isPreview}
          initiative={initiative}
          initiativeParticipation={initiativeParticipation}
          showSurvey={false}
        />
      );
    }

    if (participantType === 'Employee') {
      return (
        <div style={{ paddingLeft: `${depth * 24}px` }}>
          <EmployeeLabel
            employeeId={participantId}
            employeeName={label}
            archived={archived}
          />
        </div>
      );
    }

    return <strong className={archived ? 'text-muted' : ''}>{label}</strong>;
  };

  return (
    <tr className={styles.initiativeParticipationsTableRow}>
      <td>{renderParticipant()}</td>
      {initiative.completionTracked && (
        <React.Fragment>
          <td style={{ width: '200px' }}>
            <InitiativeParticipationStatus
              initiative={initiative}
              initiativeParticipation={initiativeParticipation}
            />
          </td>
          <td
            className={`${styles.initiativeParticipationsTableRow} ${styles.completionButton}`}
          >
            {childrenCount === 0 && (
              <InitiativeParticipationCompletionButton
                isPreview={isPreview}
                initiative={initiative}
                initiativeParticipation={initiativeParticipation}
              />
            )}
          </td>
        </React.Fragment>
      )}
    </tr>
  );
};

InitiativeParticipationsTableRow.propTypes = {
  initiative: PropTypes.shape({
    completionTracked: PropTypes.bool,
  }).isRequired,
  initiativeParticipation: PropTypes.shape({
    id: PropTypes.number.isRequired,
    childrenCount: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    participantId: PropTypes.number.isRequired,
    participantType: PropTypes.oneOf(['Employee', 'Group']),
  }).isRequired,
};

export default InitiativeParticipationsTableRow;
